import { action } from 'satcheljs';
export var onSelectFolderComplete = action('ON_SELECT_FOLDER_COMPLETE');
export var onSingleMailItemSelected = action('ON_SINGLE_MAIL_ITEM_SELECT');
//# sourceMappingURL=mailListActions.js.map